#import "~/graphql/fragments/CraftLink.graphql"

fragment ContentBlockSummaryCards on contentBlocks_summaryCards_BlockType {
    sectionTitle
    sectionDescription

    summaryCards {
        ... on summaryCard_Entry {
            tagLabel
            title
            description

            cta {
                ... CraftLink
            }
        }
    }

    anchorId
    anchorLabel
}
